import { render, staticRenderFns } from "./sw-app-nav.vue?vue&type=template&id=64437efe&"
import script from "./sw-app-nav.vue?vue&type=script&lang=ts&"
export * from "./sw-app-nav.vue?vue&type=script&lang=ts&"
import style0 from "./sw-app-nav.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports